module.exports = __webpack_public_path__ + "img/yell-green.72e8e0a6.png";